/**
 * Focus: A class that focus to targets elements 
 *
 * Put two arguments on the element that triggers the toggle:
 * - data-focus = Target that will be set focus
 * - example: data-focus='.topbar .search-input'
 *
 */
;(function ($, window) { // eslint-disable-line no-extra-semi
    'use strict';

    /**
     * Focus component constructor
     * @param $element
     * @param target
     * @param auto
     */
    var Focus = function ($element, target, auto, options) {
        this._$el = $element;
        this._target = target;
        this._options = $.extend(true, Focus.config, options);

        /**
         * Auto-toggle as soon as we hit an `auto` = true
         */
        if (auto === true) {
            return this.setFocus();
        }

        this._$el.on('click', this.setFocus.bind(this));
    };
    
    /*
     * Default settings
     */
    Focus.config = {
        classes: {
            focus: 'is--focus'
        }  
    };
    
    /**
     * SetFocus on the target
     */
    Focus.prototype.setFocus = function () {

        //check if element is focused
        if(this._$el.hasClass(this._options.classes.focus)) {
            
            //remove class
            this._$el.removeClass(this._options.classes.focus);
            
            //reset input field
            $(this._target).val('');    
                    
        } else {
            
            //set focus to input
            $(this._target).focus();    
            
            //add focus class to trigger element
            this._$el.addClass(this._options.classes.focus);
        }
    };

    /**
     * Attach new focus
     * @private
     */
    Focus.prototype._attach = function () {
        var $el = $(this),
            target = $el.data('focus'),
            auto = $el[0].hasAttribute('data-focus-auto') || false,
            options = $el.data('focus-options');

        new Focus($el, target, auto, options);
    };

    /**
     * Attach listeners to document
     */
    $(function () {
        /**
         * Travel through the DOM for data-focus attributes
         */
        $('[data-focus]').each(Focus.prototype._attach);

        /**
         * Setup a jQuery chainable plugin for attaching to injected elements after page load
         * @type {*}
         */
/*
        $.fn.jqFocus = function () {
            $(this).each(Focus.prototype._attach);
        };
*/
    });

})(jQuery, window);
